import { createFileRoute } from "@tanstack/react-router";
import { ForbiddenPage } from "../../components/forbidden-page";
import { WrapAuthProjectRoutes } from "../../scaffolding/wrap-project-routes";

export const Route = createFileRoute("/_auth/_project")({
  component: WrapAuthProjectRoutes,
  errorComponent: ({ error }: { error: unknown }) => {
    if (
      error instanceof Object &&
      "data" in error &&
      error.data instanceof Object &&
      "httpStatus" in error.data &&
      error.data.httpStatus === 403
    ) {
      return <ForbiddenPage />;
    }
    throw error;
  },
});
